module.exports = __webpack_public_path__ + "static/ro-workshops-8-b8a81cb50a3f934547f3505b2a4a6ade.jpg";